// Bloquea acceso a pantallas de compra/suscripcion si el profile no tiene
// nombre + telefono. Si faltan, muestra pantalla con CTA a /cliente/perfil.

import { Link } from 'react-router-dom'
import { useAuth } from '../lib/AuthContext'

export default function RequirePerfilCompleto({ children }) {
  const { profile, loading } = useAuth()

  if (loading) return null

  const tieneNombre = !!(profile?.nombre && profile.nombre.trim().length > 1)
  const tienePhone = !!(profile?.phone && profile.phone.trim().length >= 8)

  if (tieneNombre && tienePhone) return children

  return (
    <div style={{ minHeight: '100vh', background: '#F8FAFC', fontFamily: "'Inter', system-ui, sans-serif", display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div style={{
        maxWidth: 480, width: '100%',
        background: '#fff', borderRadius: 20, padding: 32,
        border: '1px solid #e2e8f0',
        boxShadow: '0 8px 40px rgba(26,52,97,.08)',
        textAlign: 'center',
      }}>
        <div style={{ fontSize: 56, marginBottom: 12 }}>👤</div>
        <h2 style={{ color: '#1a3461', margin: '0 0 10px' }}>Completá tus datos primero</h2>
        <p style={{ color: '#64748b', margin: '0 0 20px', lineHeight: 1.5, fontSize: 14 }}>
          Para suscribirte o comprar necesitamos tu <strong>nombre completo</strong> y <strong>teléfono</strong>.
          Te lleva 30 segundos.
        </p>

        <div style={{
          background: '#fef3c7', border: '1px solid #fde68a',
          borderRadius: 10, padding: '10px 14px', marginBottom: 18,
          fontSize: 13, color: '#78350f', textAlign: 'left',
        }}>
          <div style={{ marginBottom: 4 }}>Te falta:</div>
          <ul style={{ margin: 0, paddingLeft: 20 }}>
            {!tieneNombre && <li>Nombre y apellido</li>}
            {!tienePhone && <li>Teléfono (lo necesitamos para coordinar entregas)</li>}
          </ul>
        </div>

        <Link to="/cliente/perfil" style={{
          display: 'inline-block',
          padding: '13px 28px',
          background: '#1a3461', color: '#fff',
          borderRadius: 10, fontWeight: 700, fontSize: 14,
          textDecoration: 'none',
        }}>
          Ir a Mi perfil →
        </Link>
        <div style={{ marginTop: 14 }}>
          <Link to="/cliente" style={{ color: '#64748b', fontSize: 13, textDecoration: 'none' }}>
            ← Volver al panel
          </Link>
        </div>
      </div>
    </div>
  )
}
